export const dialogActionsStyle = {
  margin: '1.5rem',
  padding: '0rem',
}
